export enum EShopCategory {
  Antiviruses = 'antiviruses',
  SpeedBonuses = 'speed-bonuses',
  Routers = 'routers',
  Intercom = 'intercom',
  Sale = 'special-offers',
  PartnerServices = 'partner-service-with-phone-check',
  Decoders = 'decoders',
  BonusToAll = 'bonus-to-all',
  YandexStation = 'yandex-stanciya',
  YandexStationLite = 'yandex-stanciya-lite',
  SafeKids = 'safe-kids',
  LoyaltyProgram = 'loyalty-program',
  Products = 'products',
  Subscriptions = 'subscriptions',
  Multibundle = 'multibundle',
  Videocontrol = 'videocontrol',
}

export enum EExpandShopItems {
  Advertising = 'advertising',
  Category = 'category',
  Props = 'props',
  Labels = 'labels',
  CategoryProps = 'category.props',
}
